import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = ({ className = '', compact = false }) => {
  const { t, i18n } = useTranslation('common');

  // Simplified language configuration
  const supportedLanguages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'es', name: 'Español', flag: '🇪🇸' }
  ];

  const currentLanguage = i18n.language || 'en';

  const getCurrentLanguageInfo = () => {
    return supportedLanguages.find(lang => lang.code === currentLanguage) || supportedLanguages[0];
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isChanging, setIsChanging] = useState(false);

  const handleLanguageChange = async (languageCode) => {
    if (languageCode === currentLanguage || isChanging) return;

    setIsChanging(true);
    try {
      await i18n.changeLanguage(languageCode);
      setIsDropdownOpen(false);
    } catch (error) {
      console.error('Failed to change language:', error);
    } finally {
      setIsChanging(false);
    }
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const currentLangInfo = getCurrentLanguageInfo();

  return (
    <div className={`language-selector ${className} ${compact ? 'compact' : ''}`}>
      <button
        className={`language-selector-trigger ${isDropdownOpen ? 'open' : ''} ${isChanging ? 'changing' : ''}`}
        onClick={toggleDropdown}
        disabled={isChanging}
        title={t('languageSelector.currentLanguage', { name: currentLangInfo.name })}
      >
        <span className="language-flag">{currentLangInfo.flag}</span>
        {!compact && (
          <span className="language-name">{currentLangInfo.name}</span>
        )}
        <span className="dropdown-arrow">
          {isChanging ? '⟳' : (isDropdownOpen ? '▲' : '▼')}
        </span>
      </button>

      {isDropdownOpen && (
        <>
          <div
            className="language-selector-overlay"
            onClick={() => setIsDropdownOpen(false)}
          />
          <div className="language-selector-dropdown">
            {supportedLanguages.map((language) => (
              <button
                key={language.code}
                className={`language-option ${
                  language.code === currentLanguage ? 'active' : ''
                } ${isChanging ? 'disabled' : ''}`}
                onClick={() => handleLanguageChange(language.code)}
                disabled={isChanging || language.code === currentLanguage}
              >
                <span className="language-flag">{language.flag}</span>
                <span className="language-name">{language.name}</span>
                {language.code === currentLanguage && (
                  <span className="check-mark">✓</span>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;